<template>
  <v-container fluid pa-0>
    <v-layout>
      <v-flex xs12 md6 class="panel" id="panel1">
        <v-img
          style="height: 350px"
          class="hidden-md-and-up"
          :src="require('@/assets/img/studomat1.png')"
        >
          <v-layout align-center justify-center column>
            <img height="200" class="pt-4" :src="require('@/assets/img/studomat.svg')">
            <v-flex xs12 md6 class="pt-3" style="max-height: 40px !important">
              <p class="pt-2">
                Preuzmite aplikaciju eIndex
                <br>Sveučilišta u Mostaru
              </p>

              <v-layout row justify-center align-center>
                <v-flex xs6>
                  <a
                    href="https://play.google.com/store/apps/details?id=ba.sum.eindeks&hl=en_US&gl=US"
                    target="_blank"
                    style="text-decoration: none"
                  >
                    <img height="35px" :src="require('@/assets/img/google-play.svg')">
                  </a>
                </v-flex>
                <v-flex xs6>
                  <a
                    href="https://apps.apple.com/us/app/eindeks-sum/id1597738916"
                    target="_blank"
                    style="text-decoration: none"
                  >
                    <img height="35px" :src="require('@/assets/img/ios.svg')">
                  </a>
                </v-flex>
              </v-layout>
            </v-flex>
          </v-layout>
          <div class="top-right">
            <img height="40" :src="require('@/assets/img/sumit.svg')">
          </div>
        </v-img>

        <v-layout align-center justify-center pa-2>
          <v-flex xs12 md10 class>
            <v-layout row pt-3 pr-2 pb-2>
              <img height="70" :src="require('@/assets/img/logo.png')">
            </v-layout>
            <v-divider></v-divider>
            <v-spacer></v-spacer>
            <v-layout class="pt-5 pb-0" align-center justify-center>
              <v-flex xs10>
                <p class="title" style="color: #084776">StUdoMat</p>
              </v-flex>
            </v-layout>
            <v-layout style="background-color: #F2F2F2; margin-left: -20px; margin-right: -20px" class="pt-3 pb-0 hidden-sm-and-up" align-center justify-center>
              <v-flex xs10>
                <p class="subheading" style="color: #084776">Prijava s eduID elektroničkim identitetom</p>
              </v-flex>
            </v-layout>
            <v-layout  class="pt-3 pb-0 hidden-xs-only" align-center justify-center>
              <v-flex xs10>
                <p class="subheading" style="color: #084776">Prijava s eduID elektroničkim identitetom</p>
              </v-flex>
            </v-layout>
            <v-layout pt-3 align-center justify-center>
              <v-flex xs12 md9>
                <a style="width: 100%; color: white; text-decoration: none;" href="https://is.sum.ba/prod/f?p=1101:2:3146472111497:::::">
                  <div class="login-btn blue elevation-0">
                    <span class="login-btn-icon"><img class="mx-3 my-3" :src="require('@/assets/img/eduID_white.svg')" /></span>
                    <div class="login-btn-text">
                      <v-icon color="white" class="pr-2 text-body-2 text-md-body-1">mdi-shield-check</v-icon>
                      <span class="text-body-2 text-md-body-1 white--text">Prijava putem eduID</span>
                    </div>
                  </div>
                </a>
<!--                <a href="https://is.sum.ba/prod/f?p=1101:2:3146472111497:::::" style="text-decoration: none">-->
<!--                <div-->
<!--                  style="background-color: #cc2424; height: 50px; border-radius: 4px"-->
<!--                >-->
<!--                  <img height="50"  style="-->
<!--                            display: block;-->
<!--                            float: left;-->
<!--                            padding: 4px;-->
<!--                            clear: both;-->
<!--                            border-right: 1px solid #ea6b66;-->
<!--                            " :src="require('@/assets/img/aai_logo_white.svg')"/><p class="pt-3" style="color: white">Prijava putem AAI@SUM</p>-->
<!--                </div>-->
<!--                </a>-->
              </v-flex>
            </v-layout>
            <!-- <v-layout align-center justify-center class="pt-0 pb-3">
              <p class="display-2" style="color: #084776">STUDOMAT</p>
            </v-layout> -->
            <v-spacer></v-spacer>
            <v-layout align-center justify-center>
              <v-flex xs12 md9>
                <!-- <form>
                  <v-text-field
                    box
                    color="#084776"
                    v-model="name"
                    :rules="rules"
                    counter="8"
                    :error-messages="errors.collect('name')"
                    label="Korisničko ime"
                    data-vv-name="name"
                    required
                    append-icon="fas fa-user"
                    border
                    outline
                    class="pb-2"
                    style="color: #084776"
                  ></v-text-field>
                  <v-text-field
                    color="#084776"
                    label="Lozinka"
                    :append-icon="show ? 'visibility' : 'visibility_off'"
                    :type="show ? 'text' : 'password'"
                    name="input-10-2"
                    @click:append="show = !show"
                    outline
                  ></v-text-field>
                </form> -->
              </v-flex>
            </v-layout>
            <!-- <v-layout >
              <v-flex xs12 md9 style="color: #084776; font-size: 1.4em" >
                Zaboravili ste lozinku?
              </v-flex>
            </v-layout> -->
            <!-- <v-layout pt-1 align-center justify-center>
              <v-flex xs12 md9>
                <v-btn dark class="btn" color="#084776">POTVRDA</v-btn>
              </v-flex>
            </v-layout> -->

            <v-layout pt-3 align-center justify-center>
              <v-flex xs12 md9>
                <v-btn
                  flat
                  color="#084776"
                  class="btn-image-2 mr-0 ml-0"
                  href="https://rokovi.is.sum.ba/"
                  target="_blank"
                >
                  <v-icon left small>far fa-calendar-alt</v-icon>Ispitni rokovi
                </v-btn>
              </v-flex>
            </v-layout>
            <br>
            <v-layout style="background-color: #F2F2F2; margin-left: -20px; margin-right: -20px" class="pt-3 pb-0 hidden-sm-and-up" align-center justify-center>
              <v-flex xs10>
                <p class="subheading" style="color: #084776">Studomat je modul Informacijskog sustava Sveučilišta u Mostaru (ISS) namijenjen studentima. Studomat je također dostupan kao dio mobilne aplikacije Sveučilišta koji možete preuzeti na svoje mobilne uređaje. Za sva pitanja slobodno se javite ISS administratoru na svojoj sastavnici.</p>
              </v-flex>
            </v-layout>
            <v-layout  class="pt-3 pb-0 hidden-xs-only" align-center justify-center>
              <v-flex xs10>
                <p class="subheading" style="color: #084776">Studomat je modul Informacijskog sustava Sveučilišta u Mostaru (ISS) namijenjen studentima. Studomat je također dostupan kao dio mobilne aplikacije Sveučilišta koji možete preuzeti na svoje mobilne uređaje. Za sva pitanja slobodno se javite ISS administratoru na svojoj sastavnici.</p>
              </v-flex>
            </v-layout>
            <v-layout pt-1 align-center justify-center class="hidden-sm-and-up">
              <v-flex d-flex xs12 child-flex pr-2>
                    <v-card flat class="pt-3 pb-0">
                      <v-card-text class="pl-0 pt-0 pb-0 pr-0">
                        <v-dialog v-model="dialog1" persistent max-width="90%" scrollable>
                          <template v-slot:activator="{ on }">
                            <v-btn
                              flat
                              class="footer-btn-1"
                              color="#084776"
                              v-on="on"
                            >ISS administratori</v-btn>
                          </template>
                          <v-card>
                            <v-card-title class="headline" style="color: #084776">
                              ISS administratori
                              <v-spacer></v-spacer>
                              <v-btn icon @click="dialog1 = false">
                                <v-icon color="#084776">fas fa-times</v-icon>
                              </v-btn>
                              <br>
                              <span
                                style="color: grey; font-size: 12px"
                              >Za sve upite vezano za studomat javite se kontakt osobi na vašoj sastavnici!</span>
                            </v-card-title>
                            <v-divider></v-divider>
                            <v-card-text>
                              <v-layout>
                                <v-flex md12>
                                  <v-list>
                                    <div v-for="(admin, i) in iss_administratori" :key="i">
                                      <v-list-tile>
                                        <v-list-tile-content>
                                          <v-list-tile-title>{{admin.name}}</v-list-tile-title>
                                          <v-list-tile-title>
                                            <v-tooltip bottom>
                                              <template v-slot:activator="{ on }">
                                                <span v-on="on" style="color: #084776">{{admin.fax}}</span>
                                              </template>
                                              <span>{{admin.fax}}</span>
                                            </v-tooltip>
                                          </v-list-tile-title>
                                          <v-list-tile-sub-title class="hidden-xs-only">
                                            <v-layout row>
                                              <v-flex md3>
                                                <span>{{admin.mail}}</span>
                                              </v-flex>
                                            </v-layout>
                                          </v-list-tile-sub-title>
                                        </v-list-tile-content>
                                        <v-list-tile-action>
                                          <v-icon color="#084776">fas fa-envelope</v-icon>
                                        </v-list-tile-action>
                                      </v-list-tile>
                                      <v-list-tile s class="hidden-sm-and-up">
                                        <div>
                                          <v-list-tile-sub-title>
                                            <span>
                                              <a
                                                class="mailto"
                                                :href="'mailto:' + admin.mail"
                                              >{{admin.mail}}</a>
                                            </span>
                                          </v-list-tile-sub-title>
                                        </div>
                                        <br>
                                      </v-list-tile>

                                      <v-divider ></v-divider>
                                    </div>
                                  </v-list>
                                </v-flex>
                              </v-layout>
                              <!-- <v-layout row v-for="i in 3" :key="i">
                        
                          <v-flex md2>ikona</v-flex>
                          <v-flex md8>
                            <v-layout column>
                              <v-flex md12>
                                <v-layout row>
                                  <v-flex md4>Ime Prezime - </v-flex>
                                  <v-flex md8>Sastavnica</v-flex>
                                </v-layout>
                              </v-flex>
                              <v-flex md12>mail</v-flex>
                            </v-layout>
                          </v-flex>
                          <v-flex md2>ikona</v-flex>
                        <v-divider></v-divider>
                              </v-layout>-->
                            </v-card-text>
                          </v-card>
                        </v-dialog>
                      </v-card-text>
                    </v-card>
                  </v-flex>
            </v-layout>

            <v-layout column justify-center style="bottom: 5px">
              <v-flex
                py-3
                text-xs-center
                xs12
                class="footer hidden-sm-and-down pb-0"
                style="color: #084776"
              >
                <div class="pr-5 pl-5 mr-3 ml-3">
                  <v-divider></v-divider>
                </div>
                
                <v-layout row wrap justify-start align-center>
                  <v-flex d-flex xs12 sm6 md2 class="pl-5">
                    <!-- <v-layout row wrap justify-center="" align-center=""> -->
                    <!-- <v-flex d-flex>
                        <v-card flat>
                          <v-card-title class="pl-0 pb-0 pt-0">
                            <img style="height: 40px" :src="require('@/assets/img/iss-plavi.svg')"/>
                            <img class="pl-3" style="height: 40px" :src="require('@/assets/img/studomat-icon.svg')"/>
                          </v-card-title>
                        </v-card>
                    </v-flex>-->
                    <!-- <v-flex d-flex> -->
                    <img style="height: 35px; " :src="require('@/assets/img/iss-plavi.svg')">
                    <!-- <img class="pl-3" style="height: 40px" :src="require('@/assets/img/studomat-icon.svg')"/> -->
                  </v-flex>
                  <v-flex d-flex xs12 sm6 md5>
                    <v-divider vertical></v-divider>
                    <v-card flat class="pb-0">
                      <v-card-text class="pl-4 pt-3 pb-0">
                        
                        <strong class="pr-4"> Copyright ©
                          <a
                            style="text-decoration: none; color: #084776;"
                            href="http://sumit.sum.ba/"
                            target="_blank"
                          >SUMIT</a> {{ new Date().getFullYear() }}
                        </strong>
                      </v-card-text>
                    </v-card>
                    <!-- </v-flex> -->
                    <!-- </v-layout> -->
                  </v-flex>
                  <v-flex d-flex xs12 sm6 md5 child-flex>
                    <v-card flat class="pt-0 pb-0">
                      <v-card-text class="pl-0 pt-0 pb-0 pr-0">
                        <v-dialog v-model="dialog" persistent max-width="40%" scrollable>
                          <template v-slot:activator="{ on }">
                            <v-btn
                              flat
                              class="footer-btn mt-4"
                              color="#084776"
                              v-on="on"
                            >ISS administratori</v-btn>
                          </template>
                          <v-card>
                            <v-card-title class="headline" style="color: #084776">
                              ISS administratori
                              <v-spacer></v-spacer>
                              <v-btn icon @click="dialog = false">
                                <v-icon color="#084776">fas fa-times</v-icon>
                              </v-btn>
                              <br>
                            </v-card-title>
                            <span
                              class="pl-3 pb-2"
                              style="color: grey; font-size: 12px"
                            >Za sve upite vezano za studomat javite se kontakt osobi na vašoj sastavnici!</span>
                            <v-divider></v-divider>
                            <v-card-text>
                              <v-layout>
                                <v-flex md12>
                                  <v-list two-line>
                                    <div v-for="(admin, i) in iss_administratori" :key="i">
                                      <v-list-tile>
                                        <v-list-tile-action>
                                          <v-list-tile-avatar>
                                            <img src="../assets/img/dialog-ikona.png" alt="John">
                                          </v-list-tile-avatar>
                                        </v-list-tile-action>

                                        <v-list-tile-content>
                                          <v-list-tile-title>
                                            {{admin.name}}
                                            <v-tooltip bottom>
                                              <template v-slot:activator="{ on }">
                                                <span
                                                  v-on="on"
                                                  style="color: #084776"
                                                >- {{admin.fax}}</span>
                                              </template>
                                              <span>{{admin.fax}}</span>
                                            </v-tooltip>
                                          </v-list-tile-title>
                                          <v-list-tile-sub-title class="hidden-xs-only">
                                            <v-layout row>
                                              <v-flex md3>
                                                <span>
                                                  <a
                                                    class="mailto"
                                                    :href="'mailto:' + admin.mail"
                                                  >{{admin.mail}}</a>
                                                </span>
                                              </v-flex>
                                            </v-layout>
                                          </v-list-tile-sub-title>
                                        </v-list-tile-content>
                                        <v-list-tile-action>
                                          <v-icon color="#084776">fas fa-envelope</v-icon>
                                        </v-list-tile-action>
                                      </v-list-tile>
                                      <v-divider inset></v-divider>
                                    </div>
                                  </v-list>
                                </v-flex>
                              </v-layout>
                              <!-- <v-layout row v-for="i in 3" :key="i">
                        
                          <v-flex md2>ikona</v-flex>
                          <v-flex md8>
                            <v-layout column>
                              <v-flex md12>
                                <v-layout row>
                                  <v-flex md4>Ime Prezime - </v-flex>
                                  <v-flex md8>Sastavnica</v-flex>
                                </v-layout>
                              </v-flex>
                              <v-flex md12>mail</v-flex>
                            </v-layout>
                          </v-flex>
                          <v-flex md2>ikona</v-flex>
                        <v-divider></v-divider>
                              </v-layout>-->
                            </v-card-text>
                          </v-card>
                        </v-dialog>
                      </v-card-text>
                    </v-card>
                  </v-flex>
                </v-layout>
              </v-flex>

              <v-flex py-1 text-xs-center xs12 class="hidden-md-and-up pb-0" style="color: #084776">
                <v-layout row wrap justify-start align-center>
                  <v-flex d-flex xs2>
                    <img style="height: 50px; " :src="require('@/assets/img/iss-plavi.svg')">
                  </v-flex>
                  <v-divider class="pl-5" vertical></v-divider>
                  <v-spacer></v-spacer>
                  <v-flex d-flex xs8>
                    
                    <v-card flat class="pb-0">
                      <v-card-text class="pl-4 pt-3 pb-3 title">
                        Copyright ©
                        <strong class="pr-4">
                          <a
                            style="text-decoration: none; color: #084776;"
                            href="http://sumit.sum.ba/"
                            target="_blank"
                          >SUMIT</a> {{ new Date().getFullYear() }}
                        </strong>
                      </v-card-text>
                    </v-card>
                    <!-- </v-flex> -->
                    <!-- </v-layout> -->
                  </v-flex>
                  
                </v-layout>
              </v-flex>
              <!-- <v-flex py-3 text-xs-center xs12 class="hidden-md-and-up pb-0" style="color: #084776"></v-flex> -->
            </v-layout>
          </v-flex>
        </v-layout>
      </v-flex>
      <v-flex md6 class="panel hidden-sm-and-down" id="studomat-bg">
        <v-layout row wrap fill-height justify-center align-center>
          <v-flex xs10>
            <img height="200" :src="require('@/assets/img/studomat.svg')">
            <p class="pt-2">
              Preuzmite aplikaciju eIndex
              <br>Sveučilišta u Mostaru
            </p>

            <v-layout row justify-center align-center>
              <v-flex xs3>
                <a
                  href="https://play.google.com/store/apps/details?id=ba.sum.eindeks&hl=en_US&gl=US"
                  target="_blank"
                  style="text-decoration: none"
                >
                  <img height="45px" :src="require('@/assets/img/google-play.svg')">
                </a>
              </v-flex>
              <v-flex xs3>
                <a
                  href="https://apps.apple.com/us/app/eindeks-sum/id1597738916"
                  target="_blank"
                  style="text-decoration: none"
                >
                  <img height="45px" :src="require('@/assets/img/ios.svg')">
                </a>
              </v-flex>
            </v-layout>
            <v-layout row wrap fill-height justify-center align-center>
              <v-flex xs10>
                <div class="bottom-right">
                  <img height="100" :src="require('@/assets/img/sumit.svg')">
                </div>
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>

        <!-- <v-img class :src="require('@/assets/img/studomat1.png')"> -->
        <!-- <v-layout align-center justify-center column fill-height>
                <img height="200" :src="require('@/assets/img/studomat.svg')">
                
                  <v-flex xs12 md6 class="pt-3" style="max-height: 40px !important">
                    <v-btn flat dark class="btn-image mr-0 ml-0" href="https://is.sum.ba:4443/ords/f?p=1107:99:0:::::" target="_blank"><v-icon left small>far fa-calendar-alt</v-icon>Ispitni rokovi</v-btn>
                  </v-flex>
                
              </v-layout>
        <div><img height="100" :src="require('@/assets/img/sumit.svg')"></div>-->
        <!-- <div class="bottom-right">
            <img height="100" :src="require('@/assets/img/sumit.svg')">
          </div>
          <div class="centered ma-0">
            <v-layout row wrap justify-center align-center>
              <img height="200" :src="require('@/assets/img/studomat.svg')">

              <v-flex
                xs12
                md7
                class="ma-0"
                style="margin-left: auto !important;
  margin-right: auto !important;"
              >
        <p class="pt-2">Download SUM aplikacije za prijavu i pregled ispitnih rokova</p>-->

        <!-- <v-btn
                    flat
                    dark
                    class="btn-image mr-0 ml-0"
                    href="https://rokovi.is.sum.ba/"
                    target="_blank"
                  >
                    <v-icon left small>far fa-calendar-alt</v-icon>Ispitni rokovi
        </v-btn>-->
        <!-- </v-flex>
              <v-flex xs6>
                <img height="45px" :src="require('@/assets/img/google-play.svg')">
              </v-flex>
              <v-flex xs6>
                <img height="45px" :src="require('@/assets/img/ios.svg')">
              </v-flex>
            </v-layout>
        </div>-->
        <!-- </v-img> -->
      </v-flex>
    </v-layout>
  </v-container>
</template>

<style>
</style>
<script>
import Vue from "vue";
import VeeValidate from "vee-validate";

Vue.use(VeeValidate);

export default {
  $_veeValidate: {
    validator: "new"
  },

  data: () => ({
    dialog: false,
    dialog1: false,
    show: false,
    name: "",
    password: "",
    rules: [
      v =>
        v.length <= 8 ||
        "Korisničko ime je predugačko, morate unijeti korisničko ime od 8 znakova"
    ],
    dictionary: {
      custom: {
        name: {
          required: () => "Ovo polje ne može biti prazno",
          max:
            "Korisničko ime je predugačko, morate unijeti korisničko ime od 8 znakova"
          // custom messages
        }
      }
    },
    iss_administratori: [
      {
        fax: "Agronomski i prehrambeno tehnološki fakultet",
        name: "Jurica Primorac",
        mail: "jurica.primorac@aptf.sum.ba"
      },
      {
        fax: "Akademija likovnih umjetnosti",
        name: "Nikol Zadro",
        mail: "nikol.zadro@alu.sum.ba"
      },
      {
        fax: "Ekonomski fakultet",
        name: "Anela Čolak ",
        mail: "anela.colak@ef.sum.ba"
      },
      {
        fax: "Fakultet građevinarstva, arhitekture i geodezije",
        name: "Božo Penavić",
        mail: "bozo.penavic@gf.sum.ba"
      },
      {
        fax: "Fakultet prirodoslovno-matematičkih i odgojnih znanosti",
        name: "Danko Lovrić",
        mail: "danko.lovric@fpmoz.sum.ba"
      },
      {
        fax: "Fakultet strojarstva, računarstva i elektrotehnike",
        name: "Ana Pinjuh",
        mail: "ana.pinjuh@fsre.sum.ba"
      },
      {
        fax: "Fakultet zdravstvenih studija",
        name: "Toni Perić",
        mail: "toni.peric@fzs.sum.ba"
      },
      {
        fax: "Farmaceutski fakultet",
        name: "Franjo Jurilj",
        mail: "franjo.jurilj@farf.sum.ba"
      },
      {
        fax: "Filozofski fakultet",
        name: "Krešimir Čavar",
        mail: "kresimir.cavar@ff.sum.ba"
      },
      {
        fax: "Medicinski fakultet",
        name: "Olivera Boras",
        mail: "olivera.boras@mef.sum.ba"
      },
      {
        fax: "Pravni fakultet",
        name: "Marko Smiljanić",
        mail: "marko.smiljanic@pf.sum.ba"
      }
    ],
    mounted() {
      this.$validator.localize("en", this.dictionary);
    },
    methods: {
      submit() {
        this.$validator.validateAll();
      }
    }
  })
};
</script>

<style>
.login-btn {
  position: relative;
  display: flex;
  width: 100%;
  height: 56px;
  justify-content: center;
  align-items: center;
  border-radius: 4px;
}

.login-btn-icon {
  position: absolute;
  left: 0;
  height: 100%;
  width: 80px;
  background-color: #004379;
  border-top-left-radius: 4px;
  border-bottom-left-radius: 4px;
}

@media only screen and (max-width: 380px) {
  .login-btn-text {
    margin-left: 80px !important;
  }
}
</style>